module.exports = __webpack_public_path__ + "img/a.ed748ec3.png";